export interface ServiceProvider {
  objectUUID: string;
  features?: {
    plugins?: {
      [key: string]: boolean;
    };
    ui?: {
      [key: string]: boolean;
    };
  };
}

export const getProvider = () =>
  JSON.parse(sessionStorage.getItem('converse_authuser') || '{}')
    .serviceProvider;
